/* eslint-disable react/no-unused-prop-types */
import useCalendars from 'data/firestore/agent/calendar/useCollection';
import { CalendarPickerProps } from './types';
import CalendarPickerVariantSelect from './select';
import CalendarPickerVariantPicker from './picker';

const CalendarPicker = (props: CalendarPickerProps) => {
    const {
        agentId = '',
        variant = 'select',
        calendars: calendarsFromProps,
        ...rest
    } = props;

    const { data: fetchedCalendars = [], isLoading } = useCalendars(agentId, {
        disabled: !agentId || calendarsFromProps !== undefined,
        track: [agentId],
    });
    const calendars = calendarsFromProps ?? fetchedCalendars;

    if (variant === 'picker') {
        return (
            <CalendarPickerVariantPicker
                {...rest}
                calendars={calendars}
                isLoading={calendarsFromProps !== undefined ? false : isLoading}
            />
        );
    }

    return (
        <CalendarPickerVariantSelect
            {...rest}
            calendars={calendars}
            isLoading={calendarsFromProps !== undefined ? false : isLoading}
        />
    );
};

export default CalendarPicker;
